// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "microsite_domain".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "microsite_domain" table (1:1 with a DB row, on the wire). */
export const micrositeDomainAtomSchema = z.object({
    id: z.string(),
    micrositeId: z.string(),
    organizationId: z.string(),
    domain: z.string(),
    isPrimary: z.boolean(),
    status: z.string(),
    verification: z.unknown().nullable(),
    lastCheckedAt: z.string().datetime().nullable(),
    errorMessage: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=micrositeDomain.js.map